import React, {useEffect, useState} from 'react';
import {useStoreActions, useStoreState} from '~/store';
import EmptyMessage from './../EmptyMessage';
import List from './List';
import {Machine} from "~/types";
import {useParams} from "react-router-dom";
import Loader from "~/app/common/Loader";

export type EquipmentsComponent = React.VFC;

const Equipments: EquipmentsComponent = () => {
    const {id} = useParams<{ id: Machine['id'] }>();
    const [fetching, setFetching] = useState<boolean>(true);
    const machineEquipments = useStoreState(state => state.documentation.machineEquipments);

    const fetchMachineEquipmentsAction = useStoreActions(actions => actions.documentation.fetchMachineEquipments);

    useEffect(() => {
        fetchMachineEquipmentsAction(id).then(() => setFetching(false));
    }, [id, fetchMachineEquipmentsAction, setFetching]);

    if (fetching) {
        return <Loader size="32"/>;
    }

    if (!machineEquipments.length) {
        return <EmptyMessage/>;
    }

    return (
        <>
            <List list={machineEquipments}/>
        </>
    );
};
export default Equipments
